import { get } from '../store/apiClient';
import { JobResponse } from '../store/slices/jobs/jobTypes';
import { formatUrl } from '../utils/urlFormatter';

// Endpoint path
const fetchJobListEndpoint = '/{0}/public.baseDetail';
const fetchAllJobsEndpoint = '/{0}/public.jobList';
const fetchJobDetailsByIdEndpoint = '/{0}/{1}/public.jobDetail';
const applyJobApplication = '/{0}/{1}/public.applicationDetail'

// Fetch job list from API
export const fetchJobsDataList = async (baseSlug: string): Promise<JobResponse> => {
  const endpoint = formatUrl(fetchJobListEndpoint, [baseSlug]);
  return get<JobResponse>(endpoint);
};

// Fetch all jobs from API
// export const fetchAllJobsList = async (baseSlug: string): Promise<JobResponse> => {
//   const endpoint = formatUrl(fetchAllJobsEndpoint, [baseSlug]);
//   return get<JobResponse>(endpoint, { withCredentials: true });
// };

// In your API file
export const fetchAllJobsList = async (baseSlug: string, filters?: Record<string, string>): Promise<JobResponse> => {
  const endpoint = formatUrl(fetchAllJobsEndpoint, [baseSlug]);
  
  // Convert filters object to URLSearchParams
  const searchParams = new URLSearchParams();
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        searchParams.append(key, value);
      }
    });
  }

  // Append search params to endpoint if they exist
  const url = searchParams.toString() 
    ? `${endpoint}?${searchParams.toString()}`
    : endpoint;
    
  return get<JobResponse>(url);
};

// Fetch job details by ID
export const fetchJobDetailsById = async (baseSlug: string, jobId: string): Promise<JobResponse> => {
  const endpoint = formatUrl(fetchJobDetailsByIdEndpoint, [baseSlug, jobId]);
  return get<JobResponse>(endpoint);
};

// export const applyJobApplicationById = async (baseSlug: string, jobId: string): Promise<JobResponse> => {
//   const endpoint = formatUrl(applyJobApplication, [baseSlug, jobId]);
//   return get<JobResponse>(endpoint);
// };

export const applyJobApplicationById = async (
  baseSlug: string, 
  jobId: string, 
  token: string | null
): Promise<JobResponse> => {
  const endpoint = formatUrl(applyJobApplication, [baseSlug, jobId]);
  return get<JobResponse>(endpoint, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const fetchLocationBySearch = async (searchQuery: string): Promise<JobResponse> => {
  const url = `/location.locationsList?search=${encodeURIComponent(searchQuery)}`;
  return get<JobResponse>(url, { withCredentials: true });
};